import LoginPage from "@pages/Auth/Client/Login";
import LoginOTP from "@pages/Auth/Client/LoginOTP";
import PasswordReset from "@pages/Auth/Client/PasswordReset";
import ResetPasswordPage from "@pages/Auth/Client/ResetPassword";
import SentEmail from "@pages/Auth/Client/SentEmail";

import LoginPageVendor from "@pages/Auth/Vendor/Login";
import PasswordResetVendor from "@pages/Auth/Vendor/PasswordReset";
import ResetPasswordPageVendor from "@pages/Auth/Vendor/ResetPassword";

export const AuthRoutes = [
	{ path: "/", name: "Login", component: LoginPage },
	{ path: "/login", name: "Login", component: LoginPage },
	{ path: "/login-otp/:token", name: "Login", component: LoginOTP },

	// forgot password
	{
		path: "/auth/client/forgot-password",
		name: "ResetPassword",
		component: PasswordReset,
	},
	{
		path: "/auth/client/reset-password",
		name: "ResetPassword",
		component: PasswordReset,
	},
	// set password
	{
		path: "/auth/client/set-password",
		name: "PasswordReset",
		component: ResetPasswordPage,
	},

	{ path: "/vendor/login", name: "Login", component: LoginPageVendor },
	// forgot password
	{
		path: "/auth/vendor/forgot-password",
		name: "ResetPassword",
		component: PasswordResetVendor,
	},
	{
		path: "/auth/vendor/reset-password",
		name: "ResetPassword",
		component: PasswordResetVendor,
	},
	// set password
	{
		path: "/auth/vendor/set-password",
		name: "PasswordReset",
		component: ResetPasswordPageVendor,
	},
	{ path: "/sent-email", name: "SentEmail", component: SentEmail },
];
